var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { assertNever, toNumber, } from '@freelancer/datastore/core';
export function transformProjectFeedData(data) {
    return {
        imgUrl: data.imgUrl,
        jobString: data.jobString,
        linkUrl: data.linkUrl,
        title: data.title,
        userId: toNumber(data.userId),
        username: data.userName,
    };
}
export function transformContestFeedData(data) {
    return {
        jobString: data.jobString,
        linkUrl: data.linkUrl,
        time: data.time * 1000,
        title: data.title,
        userId: toNumber(data.userId),
        username: data.userName,
    };
}
// This takes an API response and transforms it into a ProjectFeed object
export function transformProjectFeed(item) {
    switch (item.type) {
        case 'project': {
            return __assign({ type: item.type, id: item.type + "-" + item.id }, transformProjectFeedData(item), { currencyCode: item.currencyCode, freeBidUntil: item.free_bid_until, fulltime: Boolean(item.fulltime), hideBids: item.hidebids, maxBudget: toNumber(item.maxbudget), minBudget: toNumber(item.minbudget), publicName: undefined, recruiter: item.recruiter || false, time: item.time * 1000, description: item.appended_descr });
        }
        case 'contest': {
            return __assign({ type: item.type, id: item.type + "-" + item.id }, transformContestFeedData(item), { currencyCode: item.currencyCode, imgUrl: item.imgUrl, 
                // Contest min and max budgets are normally the same, as it is in this event type
                minBudget: toNumber(item.maxbudget), maxBudget: toNumber(item.maxbudget), time: item.time * 1000, description: item.appended_descr });
        }
        default:
            return assertNever(item.type);
    }
}
export function transformProjectFeedWS(entry) {
    switch (entry.type) {
        case 'contest':
            return __assign({ type: entry.type, id: entry.type + "-" + entry.data.id }, transformContestFeedData(entry.data), { currencyCode: entry.data.currencyCode, imgUrl: entry.data.imgUrl, maxBudget: toNumber(entry.data.maxbudget), time: entry.timestamp * 1000, description: entry.data.appended_descr });
        case 'xpContest':
            return __assign({ type: entry.type, id: entry.type + "-" + entry.data.id }, transformContestFeedData(entry.data), { currencyCode: entry.data.currencyCode, imgUrl: entry.data.imgUrl, 
                // Contest min and max budgets are normally the same, as it is in this event type
                minBudget: toNumber(entry.data.maxbudget), maxBudget: toNumber(entry.data.maxbudget), time: entry.timestamp * 1000, description: entry.data.appended_descr });
        case 'failingProject':
        case 'localJobPosted':
        case 'project': {
            var minBudget = toNumber(entry.data.minbudget);
            var maxBudget = toNumber(entry.data.maxbudget);
            return __assign({ type: entry.type, id: entry.type + "-" + entry.data.id }, transformProjectFeedData(entry.data), { currencyCode: entry.data.currencyCode, freeBidUntil: entry.data.free_bid_until, fulltime: entry.data.fulltime, hideBids: entry.data.hideBids, maxBudget: maxBudget,
                minBudget: minBudget, publicName: entry.data.publicName, recruiter: entry.data.recruiter, time: entry.timestamp * 1000, description: entry.data.appended_descr });
        }
        case 'recruiterProject': {
            var minBudget = toNumber(entry.data.minbudget);
            var maxBudget = toNumber(entry.data.maxbudget);
            return __assign({ type: entry.type, id: "project-" + entry.data.id }, transformProjectFeedData(entry.data), { currencyCode: entry.data.currencyCode, freeBidUntil: entry.data.free_bid_until, fulltime: entry.data.fulltime, hideBids: entry.data.hideBids, maxBudget: maxBudget,
                minBudget: minBudget, publicName: entry.data.publicName, recruiter: entry.data.recruiter, time: entry.timestamp * 1000, description: entry.data.appended_descr });
        }
        default:
            return assertNever(entry);
    }
}
